import React from "react";
import { DiscountTableDesktop } from "./components/DiscountTableDesktop/DiscountTableDesktop.component";
import { DiscountTableMobile } from "./components/DiscountTableMobile/DiscountTableMobile.component";

interface V1DiscountRow {
    quantityFrom: number;
    quantityTo?: number;
    price: number;
}

interface V1Props {
    type?: "Desktop" | "Mobile"; // Make `type` optional in case it's not provided
    discountTable: V1DiscountRow[];
    currentQuantity?: number;
    onRowClick?: (quantity: number) => void;
    clickableRows?: boolean;
    priceCurrency?: string;
    minimumSalesQuantity?: string;
}

export const V1 = (props: V1Props) => {
    const { type, discountTable, currentQuantity, onRowClick, clickableRows } = props;

    if (type === "Desktop") {
        return (
            <DiscountTableDesktop
                discountTable={discountTable}
                currentQuantity={currentQuantity}
                onRowClick={onRowClick}
                clickableRowsDesktop={clickableRows}
                priceCurrency={props.priceCurrency || "DKK"}
                minimumSalesQuantity={props.minimumSalesQuantity}
            />
        );
    }

    if (type === "Mobile") {
        return (
            <DiscountTableMobile
                discountTable={discountTable}
                priceCurrency={props.priceCurrency || "DKK"}
                onRowClick={onRowClick}
                clickableRows={clickableRows}
                minimumSalesQuantity={props.minimumSalesQuantity}
            />
        );
    }

    return null; // Return null if type is not defined or invalid
};
